import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { updateFilters } from '../../../features/filter/slice';
import { fetchResults } from '../../../features/results/slice';
import { getFlowrateRequest } from './utils';

import { FilterValueKey } from '../../../features/filter/utils';
import { SolutionsValueKey } from '../../../features/results/interfaces';
import { CalculationResultValues } from '../types';

const useFetchSolution = () => {
  const dispatch = useAppDispatch();
  const filtersValue = useAppSelector((state) => state.filter.filtersValue);
  const { solution: solutionsValue, isResultsLoading } = useAppSelector((state) => state.results);
  useEffect(() => {
    if (Object.keys(filtersValue).length > 0) {
      const responseRequest = getFlowrateRequest({ values: filtersValue });

      const fetchParameters = async () => await dispatch(fetchResults(responseRequest));

      fetchParameters();
    }
  }, [dispatch, filtersValue]);

  useEffect(() => {
    if (!solutionsValue || Object.keys(solutionsValue).length === 0) return;

    const calculationResultValue = filtersValue[FilterValueKey.CALCULATION_RESULT] as CalculationResultValues;

    const SolutionFilterDict =
      calculationResultValue === 'P1'
        ? {
            filterKey: FilterValueKey.SUPPLY_PRESSURE,
            solutionKey: SolutionsValueKey.INPUT_PRESSURE,
          }
        : calculationResultValue === 'P2'
        ? {
            filterKey: FilterValueKey.OUTPUT_PRESSURE,
            solutionKey: SolutionsValueKey.OUTPUT_PRESSURE,
          }
        : {
            filterKey: FilterValueKey.DISCHARGE,
            solutionKey: SolutionsValueKey.FLOWRATE,
          };

    const newValue = Number(solutionsValue[SolutionFilterDict.solutionKey]);
    if (Number.isNaN(newValue)) return;

    if (newValue === filtersValue[SolutionFilterDict.filterKey]) return;

    dispatch(
      updateFilters({
        newValue,
        key: SolutionFilterDict.filterKey,
      }),
    );
  }, [dispatch, filtersValue, solutionsValue]);
};

export default useFetchSolution;
